// extracted by mini-css-extract-plugin
export var condenced = "Quote-module--condenced--89ff6";
export var footer = "Quote-module--footer--391d2";
export var hr = "Quote-module--hr--abed1";
export var icon = "Quote-module--icon--9431c";
export var logo = "Quote-module--logo--a3d6c";
export var logoWrapper = "Quote-module--logoWrapper--37966";
export var quote = "Quote-module--quote--04f5c";
export var root = "Quote-module--root--a9a64";
export var themed = "Quote-module--themed--a7aaf";